/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignComplaintManagerCommand
 */
export interface AssignComplaintManagerCommand {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignComplaintManagerCommand
     */
    employeeIds: Array<string>;
}

/**
 * Check if a given object implements the AssignComplaintManagerCommand interface.
 */
export function instanceOfAssignComplaintManagerCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "employeeIds" in value;

    return isInstance;
}

export function AssignComplaintManagerCommandFromJSON(json: any): AssignComplaintManagerCommand {
    return AssignComplaintManagerCommandFromJSONTyped(json, false);
}

export function AssignComplaintManagerCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignComplaintManagerCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'employeeIds': json['employeeIds'],
    };
}

export function AssignComplaintManagerCommandToJSON(value?: AssignComplaintManagerCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'employeeIds': value.employeeIds,
    };
}

